import { adminHttpClient } from "../commons/adminHttpClient";

const deletePoll = (id: string): Promise<any> => {
  return adminHttpClient.delete(`/Polls/Delete`, {
    data: { id: id }
  });
};

export default deletePoll;
